import { classNameType } from "@/types/generalTypes";
import React from "react";

function Search({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      stroke="#686868"
      strokeWidth={1.5}
    >
      <path
        d="M17.4604 8.48666C20.1836 11.2099 20.1836 15.6252 17.4604 18.3484C14.7371 21.0717 10.3218 21.0717 7.59859 18.3484C4.87534 15.6252 4.87534 11.2099 7.59859 8.48666C10.3218 5.7634 14.7371 5.7634 17.4604 8.48666"
        stroke="#686868"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1119 21.9998L17.4563 18.3442"
        stroke="#686868"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Search;
